var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3263 0.219903C10.6204 0.513032 10.6204 0.988344 10.3263 1.28147L5.27402 6.31616L0.221795 1.28147C-0.0723549 0.988344 -0.0723549 0.513032 0.221795 0.219903C0.515945 -0.0733011 0.992913 -0.0733011 1.28706 0.219903L4.52075 3.44237L5.04688 3.99219C4.54688 3.99219 4.85799 3.99835 5.27402 3.99835C5.69005 3.99835 5.54688 3.99219 5.54688 3.99219L6.02728 3.44237L9.26097 0.219903C9.55514 -0.0733011 10.0321 -0.0733011 10.3263 0.219903Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.ba65297f10d9fe6e0f9d8fbf1e5da444.svg";
export { ForwardRef as ReactComponent };